<template>
    <div class="footer-bar">

        <t-button theme="default" size="medium" @click="$emit('cancel')">
            {{cancelText}}
        </t-button>
        
        <t-button size="medium" theme="primary" @click="$emit('confirm')">
            {{confirmText }}
        </t-button>

        
    </div>
</template>

<script>
    export default{
        name:'actionBar',
        props:{
            confirmText:{
                type:String,
                default:'确定'
            },
            cancelText:{
                type:String,
                default:'取消'
            }
        },
        emits: ['confirm', 'cancel']
    }
</script>

<style scoped>
    .footer-bar{
        position: fixed;
        bottom: 0;
        left: 232px;
        right: 0;
        height: 60px;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        padding: 0 20px;
        border-top: 1px solid #e1e2e3;
        z-index: 999;

    }

    .footer-bar .t-button{
        margin-right: 16px;
        border-radius: 2px;
        height: 32px;
        width: 72px;
    }

    .footer-bar .t-button:last-child {
        margin-right: 0; 
    }   
</style>